var React = require('react');

function IconSearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.53.5a7 7 0 015.5 11.32l5.17 5.16-.71.7-5.13-5.12A7 7 0 117.53.49zm0 1a6 6 0 100 12 6 6 0 000-12z"}));
}

IconSearchInline.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18"};

module.exports = IconSearchInline;

IconSearchInline.default = IconSearchInline;
